// @ts-check

import React from 'react';
import { array } from 'prop-types';
import ProfilePaper from './ProfilePaper';
import Typography from '@mui/material/Typography';
import ProfileAddress from './ProfileAddress';

/**
 * @component ProfileAddresses
 * @param {Object} props
 * @param {ProfileAddress[]} props.addresses
 * @returns {JSX.Element}
 */
function ProfileAddresses({ addresses }) {
	return (
		<ProfilePaper>
			<Typography variant="button">ADDRESSES</Typography>
			{addresses.map((address, index) => (
				<ProfileAddress key={index} index={index} address={address} />
			))}
		</ProfilePaper>
	);
}

ProfileAddresses.propTypes = { addresses: array };

export default ProfileAddresses;
